import { services } from '../data/services.js';
import SectionHeading from './shared/SectionHeading.jsx';
import SectionReveal from './shared/SectionReveal.jsx';
import { ServiceIcon, CheckIcon } from './icons/ServiceIcons.jsx';

function ServiceCard({ service, index }) {
  return (
    <SectionReveal
      delay={index * 140}
      className="perspective-1000 h-full"
    >
      <div className="group relative h-[26rem] w-full preserve-3d transition-transform duration-700 ease-smooth-out hover:rotate-y-180">
        {/* Front */}
        <div className="backface-hidden absolute inset-0 card-surface flex flex-col p-8 group-hover:shadow-card-hover">
          <div className="absolute inset-x-0 top-0 h-1 rounded-t-2xl bg-cyan-sheen opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
          <div className="mb-6 inline-grid h-16 w-16 place-items-center rounded-2xl bg-gradient-to-br from-cyan/20 to-navy-500/30 text-cyan shadow-glow">
            <ServiceIcon name={service.icon} className="h-8 w-8" />
          </div>
          <h3 className="font-heading text-2xl font-bold text-white">{service.title}</h3>
          <p className="mt-1 text-sm font-medium text-cyan/80">{service.tagline}</p>
          <p className="mt-4 flex-1 text-silver/75">{service.blurb}</p>
          <div className="mt-6 inline-flex items-center gap-2 font-heading text-sm font-semibold text-silver-light/70 transition-colors group-hover:text-cyan">
            <span>Hover to explore</span>
            <svg className="h-4 w-4 transition-transform group-hover:translate-x-1" viewBox="0 0 20 20" fill="none">
              <path d="M4 10h12m0 0l-5-5m5 5l-5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        {/* Back */}
        <div className="absolute inset-0 backface-hidden rotate-y-180 rounded-2xl glass-strong p-8 shadow-card-hover">
          <div className="flex h-full flex-col">
            <div className="mb-4 flex items-center gap-3">
              <span className="inline-grid h-10 w-10 place-items-center rounded-xl bg-cyan-sheen text-navy-900">
                <ServiceIcon name={service.icon} className="h-5 w-5" />
              </span>
              <h3 className="font-heading text-xl font-bold text-white">{service.title}</h3>
            </div>
            <ul className="flex-1 space-y-3">
              {service.details.map((d) => (
                <li key={d} className="flex items-start gap-3 text-sm text-silver-light/90">
                  <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-cyan/20 text-cyan">
                    <CheckIcon className="h-3 w-3" />
                  </span>
                  {d}
                </li>
              ))}
            </ul>
            <a
              href="#contact"
              className="mt-6 inline-flex w-fit items-center gap-2 rounded-full bg-cyan-sheen px-5 py-2.5 font-heading text-sm font-semibold text-navy-900 transition-all hover:shadow-glow"
            >
              Discuss this
            </a>
          </div>
        </div>
      </div>
    </SectionReveal>
  );
}

export default function Services() {
  return (
    <section id="services" className="section-pad relative">
      <div className="container-x">
        <SectionHeading
          eyebrow="What we do"
          title="Three pillars. One engineering standard."
          subtitle="Whether you need a system built from scratch, your stack unified, or an expert to call the shots — we plug in where it matters most."
        />

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          {services.map((s, i) => (
            <ServiceCard key={s.id} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
